import React from 'react';
import {
  Avatar,
  Banner,
  Button,
  Card,
  IconButton,
  ProgressBar,
  Text,
  useTheme,
} from 'react-native-paper';
import {useAppDispatch, useAppSelector} from '../../../store/hooks';
import {Platform, ScrollView} from 'react-native';
import {
  setIsRendering,
  setRenderingError,
  setRenderUrl,
} from '../../../store/slices/editor';
import {useShare} from '../../../hooks/useShare';

export function RenderStatusBanner() {
  const {share} = useShare();
  const isRendering = useAppSelector(
    state => state.editor.isRendering,
  );
  const isRenderingError = useAppSelector(
    state => state.editor.ffmpegError,
  );
  const logs = useAppSelector(state => state.editor.ffmpegLogs);
  const renderUrl = useAppSelector(
    state => state.editor.renderOutputURL,
  );
  const dispatch = useAppDispatch();
  const theme = useTheme();
  let RenderStatusText = !isRenderingError ? 'Rendering' : 'Error';
  if (renderUrl) RenderStatusText = 'Success';
  console.info('error', logs);
  return (
    <Banner
      theme={theme}
      visible={
        isRendering || isRenderingError || renderUrl !== undefined
      }
      style={{width: '100%'}}>
      <Card.Title
        style={{width: '100%'}}
        titleStyle={{fontSize: 20}}
        title="Render Status"
        subtitle={RenderStatusText}
        left={props => <Avatar.Icon {...props} icon="movie" />}
      />
      {isRenderingError && (
        <Card.Content>
          <ScrollView
            style={{height: 200}}
            showsVerticalScrollIndicator={false}
            showsHorizontalScrollIndicator={false}>
            <Text style={theme.fonts.bodySmall}>{logs}</Text>
          </ScrollView>
        </Card.Content>
      )}
      <Card.Actions>
        {(renderUrl || isRenderingError) && (
          <IconButton
            style={{
              // position: 'absolute',
              cursor: 'pointer',
              // right: Platform.select({native: 40, web: 0}),
              // top: Platform.select({native: 0, web: 0}),
              pointerEvents: 'auto',
              zIndex: 100,
            }}
            icon={'close'}
            mode="outlined"
            size={25}
            onPress={() => {
              dispatch(setRenderingError(false));
              dispatch(setIsRendering(false));
              dispatch(setRenderUrl(undefined));
            }}
          />
        )}
        {renderUrl && (
          <Button
            icon={'file'}
            mode={'outlined'}
            onPress={() => {
              if (Platform.OS === 'web') {
                const a = document.createElement('a');
                a.style = 'display:none;';
                document.body.appendChild(a);
                a.download = 'out.mp4';
                a.href = renderUrl;
                a.click();
              } else {
                const file = renderUrl;
                share(file);
              }
            }}>
            {'Download File'}
          </Button>
        )}
      </Card.Actions>
      {!isRenderingError && !renderUrl && (
        <ProgressBar indeterminate visible={true} />
      )}
    </Banner>
  );
}
